function Research2018() {

    return (
      <>
        <div className="ml-10 mt-5">
          <div className="flex">
            <div className="w-16">2018</div>

            <div className="w-full">
                <div className="flex">
                    <div className="w-16">Sep</div>
                    <div className="w-full">
                        <p><a href="https://gauge-theory.wixsite.com/eastasian" target='_blank'>“A K-theoretical Dijkgraaf-Witten theory.”</a></p>
                        <p>East Asian Conference on Gauge theory and Related topics, Kyoto University</p>
                    </div>
                </div>

                <div className="flex mt-2">
                    <div className="w-16">Mar</div>
                    <div className="w-full">
                        <p><a href="https://www.math-materials.jp/activity/20180301_WS.html" target='_blank'>“A construction of TQFT using K-theory.”</a></p>
                        <p>Mini-Workshop on Topological Phases and K-theory, AIMR</p>
                    </div>
                </div>
            </div>
          </div>
        </div>
      </>
    );
  }
  
  export default Research2018;